<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="majorListTitle" width="700px" @close="closePopup">
    <el-form slot="content" :model="procInfo" label-position="top" ref="procInfoForm">
      <el-row v-if="this.popupType==='ADD'" class="mr-b25">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="title-h4">프로세스 목록</div>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </el-row>
        <el-table-wrapper row-class-name="c-pointer" :data="dataList" :max-height="300" :columns="procListColumns" :column-default="columnDefault"
          :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" @row-click="selectProcess" highlight-current-row>
        </el-table-wrapper>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="프로세스 ID" prop="processId" :rules="[{ required: true, trigger: 'blur', validator: this.validateProcIdNull }]">
            <el-input :disabled="isEdit" v-model="processId" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="프로세스명" prop="processName" :rules="[{ required: true, trigger: 'blur', validator: this.validateProcNameNull }]">
            <el-input type="textarea" v-model="processName" :rows="5" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="명령어 자동 실행" prop="processStopAutostartFlag">
            <el-switch v-model="procInfo.processStopAutostartFlag" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="동작 제어 명령" prop="processCommandStart">
            <span slot="label">
              <span class="mr-r4">동작 제어 명령</span>
              <w-forbidden-command-keyword-legend ref="forbiddenCommandKeywordLegend" />
            </span>
            <el-input type="textarea" v-model="procInfo.processCommandStart" :rows="5" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="정지 제어 명령" prop="processCommandStop">
            <el-input type="textarea" v-model="procInfo.processCommandStop" :rows="5" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="포트 번호" prop="processPort">
            <el-input v-model="procInfo.processPort" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" class="mr-r4" type="solid" @click="saveIndivisualProc">저장</el-button>
      <el-button size="large" @click="cancelIndivisualProc">취소</el-button>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import { isNil, clone, cloneDeep, isUndefined } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import ForbiddenCommandScriptMixin from '@/mixins/forbidden-command-script';

const requireMSg = '필수사항을 입력해주십시오.';

export default {
  name: 'WIndivisualProcPopup',
  mixins: [ForbiddenCommandScriptMixin],
  props: {
    popupType: String,
    editRow: Object,
    selectPhysicalNode: Object,
    majorProcTypeId: Number,
    serverId: Number,
  },
  data() {
    return {
      formName: 'procInfoForm',
      majorListTitle: '',
      isEdit: false,
      showSearchTool: false,
      dataList: [],
      params: {
        objId: null,
      },
      processId: null,
      processName: null,
      procInfo: {
        processPort: null,
        processCommandStart: null,
        processCommandStop: null,
        processStopAutostartFlag: null,
      },
      columnDefault,
      procListColumns: [
        {
          prop: 'procPid',
          label: 'PID',
          width: 120,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'procName',
          label: '프로세스명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    editRow: {
      handler(row) {
        this.procInfo = clone(row);
        this.params.objId = this.selectPhysicalNode.obj.objId;
        if (this.popupType === 'ADD') {
          this.isEdit = false;
          this.majorListTitle = `[${this.selectPhysicalNode.label}] 중요 프로세스 등록`;
          this.procListLoad();
        } else {
          this.isEdit = true;
          this.majorListTitle = `[${this.selectPhysicalNode.label}] 정보`;
          this.processId = row.processId;
          this.processName = row.processName;
        }
      },
      deep: true,
    },
  },
  methods: {
    closePopup() {
      this.processId = '';
      this.processName = '';
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
      this.dataList = [];
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    /**
     * [saveIndivisualProc 중요 프로세스 개별 등록시 추가 / 수정에 따른 분기]
     * @author yelim
     * @return {[type]} [description]
     */
    saveIndivisualProc() {
      const target = '중요 프로세스';
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          // 수행금지명령어 확인 로직
          const forbiddenCommandList = this.$refs.forbiddenCommandKeywordLegend.getForbiddenCommandList();
          const scriptContents = `${this.procInfo.processCommandStart} ${this.procInfo.processCommandStop}`;
          if (this.checkForbiddenCommand(forbiddenCommandList, scriptContents)) {
            return;
          }
          if (this.popupType === 'ADD') {
            const saveParams = clone(this.procInfo);
            saveParams.objId = this.params.objId;
            saveParams.serverId = this.serverId;
            saveParams.processId = this.processId;
            saveParams.processName = this.processName;
            ServerSettingAPI.insertIndivisualMajorProcess(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, target, true));
                this.$emit('reload-data');
                this.closePopup();
              }
            });
          } else {
            const saveParams = clone(this.procInfo);
            saveParams.serverId = this.serverId;
            saveParams.processId = this.processId;
            saveParams.processName = this.processName;
            ServerSettingAPI.updateIndivisualMajorProcess(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, target, true));
                this.$emit('reload-data');
                this.closePopup();
              }
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('프로세스 정보가 입력되지 않았거나 중복됩니다.'));
        }
      });
    },
    validateProcIdNull(rule, value, callback) {
      const validValue = this[rule.field];
      if (isUndefined(validValue) || validValue === '' || isNil(validValue)) {
        callback(new Error(requireMSg));
      } else if (this.popupType === 'EDIT' && value === validValue) {
        // 수정 팝업창에서 프로세스 아이디가 같으면 체크하지 않는다.
        callback();
      } else {
        ServerSettingAPI.checkDuplicateMajorProc({
          objId: this.params.objId,
          processId: validValue,
        }).then((response) => {
          if (response.data.success && response.data.data) {
            callback(new Error('중복된 프로세스 아이디입니다.'));
          } else {
            callback();
          }
        }).catch(() => {
          callback();
        });
      }
    },
    validateProcNameNull(rule, value, callback) {
      const validValue = this[rule.field];
      if (isUndefined(validValue) || validValue === '' || isNil(validValue)) {
        callback(new Error(requireMSg));
      } else if (this.popupType === 'EDIT' && value === validValue) {
        // 수정 팝업창에서 프로세스명이 같으면 체크하지 않는다.
        callback();
      } else {
        ServerSettingAPI.checkDuplicateMajorProc({
          objId: this.params.objId,
          processName: validValue,
        }).then((response) => {
          if (response.data.success && response.data.data) {
            callback(new Error('중복된 프로세스명입니다.'));
          } else {
            callback();
          }
        }).catch(() => {
          callback();
        });
      }
    },
    procListLoad() {
      if (!isNil(this.params)) {
        ServerSettingAPI.getSettingProcessList(this.params).then((response) => {
          if (response.data.success) {
            this.dataList = cloneDeep(response.data.data);
          }
        });
      }
    },
    cancelIndivisualProc() {
      this.closePopup();
    },
    selectProcess(row) {
      this.processName = cloneDeep(row.procName);
      this.processId = cloneDeep(row.procName);
      this.$refs[this.formName].validateField('processId');
      this.$refs[this.formName].validateField('processName');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/popup/IndivisualProcPopup.vue